    // ContextMenu.jsx
    import React from 'react';

    const ContextMenu = ({ x, y, items, onClose }) => {
      const menuStyle = {
        position: 'absolute',
        top: `${y}px`,
        left: `${x}px`,
        backgroundColor: 'white',
        border: '1px solid #ccc',
        boxShadow: '2px 2px 5px rgba(0,0,0,0.2)',
        zIndex: 1000,
      };

      return (
        <div style={menuStyle} onMouseLeave={onClose}>
          <ul>
            {items.map((item, index) => (
              <li key={index} onClick={() => { item.action(); onClose(); }}>
                {item.label}
              </li>
            ))}
          </ul>
        </div>
      );
    };

    export default ContextMenu;